var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAereaauto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1429",
    "data-name": "Grupo 1429",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.1,
    height: 68.096,
    viewBox: "0 0 68.1 68.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_705",
    "data-name": "Trazado 705",
    d: "M21.825,152.975a.966.966,0,1,0,0,1.933h2.068v6.656a1.061,1.061,0,0,0,2.123,0v-6.656h2.041a.966.966,0,1,0,0-1.933Zm-4.544.939v4.509c0,1.53-.789,2.308-2.1,2.308s-2.1-.8-2.1-2.361v-4.456a1.061,1.061,0,0,0-2.123,0V158.4c0,2.818,1.578,4.267,4.191,4.267,2.586,0,4.245-1.423,4.245-4.321v-4.429a1.061,1.061,0,0,0-2.123,0m-12.464,1.45,1.334,3.167H3.483Zm-.054-2.55a1.329,1.329,0,0,0-1.251.832L.136,161.188H.109a1.4,1.4,0,0,0-.109.456.975.975,0,0,0,.98.993,1.061,1.061,0,0,0,.98-.644l.681-1.584H6.912l.653,1.5a1.115,1.115,0,0,0,1.034.725,1,1,0,0,0,1.007-1.02,1.422,1.422,0,0,0-.109-.429l-3.374-7.542a1.294,1.294,0,0,0-1.225-.832ZM32,157.725a2.884,2.884,0,0,1,2.911-2.979,2.937,2.937,0,0,1,2.939,3.033,2.885,2.885,0,0,1-2.912,2.979A2.936,2.936,0,0,1,32,157.725m-2.232.054v.027a4.938,4.938,0,0,0,5.143,4.912,5.01,5.01,0,0,0,5.171-4.992,4.938,4.938,0,0,0-5.144-4.911,4.988,4.988,0,0,0-5.17,4.965M10.423,135.207a2.037,2.037,0,0,0-.9,1.208,1.967,1.967,0,0,0,1.469,2.389,9.246,9.246,0,0,1,5.551,4.08,9.869,9.869,0,0,1,1.28,3.194,1.846,1.846,0,0,0,.87,1.261,1.954,1.954,0,0,0,1.5.269,2.229,2.229,0,0,0,.844-.4,1.971,1.971,0,0,0,.68-1.933A13.218,13.218,0,0,0,18.4,138.8v.027a13.056,13.056,0,0,0-2.5-2.094A13.222,13.222,0,0,0,12,135.019a2.388,2.388,0,0,0-.573-.071,2,2,0,0,0-1.005.258m.326-5.582a1.932,1.932,0,0,0-.217,1.986,2.011,2.011,0,0,0,1.551,1.154,14.951,14.951,0,0,1,9.144,5.69A14.31,14.31,0,0,1,24.03,145v.268c.054.215.081.4.136.618a1.847,1.847,0,0,0,1.5,1.422,1.914,1.914,0,0,0,1.687-.4,1.283,1.283,0,0,0,.272-.269,1.964,1.964,0,0,0,.408-1.718A18.773,18.773,0,0,0,22.968,134.4l.027-.027s-.218-.215-.381-.349l-.435-.4a18.654,18.654,0,0,0-5.824-3.7,18.382,18.382,0,0,0-3.62-1.047,2.308,2.308,0,0,0-.45-.046,1.873,1.873,0,0,0-1.537.8m1.415-6.254a1.911,1.911,0,0,0-.707,1.423,1.989,1.989,0,0,0,1.8,2.04,20.231,20.231,0,0,1,13.606,8.535,19.17,19.17,0,0,1,3.238,8.186q.041.362.082.725c.027.349.082.671.136,1.02a1.777,1.777,0,0,0,1.5,1.476A1.989,1.989,0,0,0,33.5,146.4a1.571,1.571,0,0,0,.3-.3,2.155,2.155,0,0,0,.408-1.718v-.027a24.246,24.246,0,0,0-6.668-14.413c-.135-.107-.3-.269-.49-.429-.408-.4-.953-.886-1.5-1.342A24.052,24.052,0,0,0,13.8,122.941a2.307,2.307,0,0,0-.3-.02,2.132,2.132,0,0,0-1.329.45",
    transform: "translate(0 -122.921)",
    fill: "#01daff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_975",
    "data-name": "Grupo 975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1732",
    "data-name": "Rect\\xE1ngulo 1732",
    fill: "none",
    stroke: "#1de9b6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.1,
    height: 68.096,
    rx: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 67.1,
    height: 67.096,
    rx: 13.5,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1430",
    "data-name": "Grupo 1430",
    transform: "translate(14.008 -110.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_965",
    "data-name": "Grupo 965",
    transform: "translate(0 122.921)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_708",
    "data-name": "Trazado 708",
    d: "M0,0,56.486.391l.391,56.486L.391,56.486Z",
    transform: "translate(-20.175 19.898) rotate(-45)",
    fill: "#01daff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAereaauto);
export default __webpack_public_path__ + "static/media/ic_aereaauto.0a5d0d62b2fc52f38abafafbafa9c603.svg";
export { ForwardRef as ReactComponent };